import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';

export const useWhatsNewItems = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const whatsNewItems = useSelector(
    (state: StoreState) => state.whatsNew.entities,
  );
  const lastSeenWhatsNewId = useSelector(
    (state: StoreState) =>
      state.session.session.userAttributes.lastSeenWhatsNewId,
  );
  const session = useSelector((state: StoreState) => state.session.session);
  const companyId = useSelector(selectActiveCompanyId);

  const hideSlideoutMenuOverride = useCallback(async () => {
    dispatch(
      usersCRUDActions.updateUserAttributes(companyId, session.id, {
        lastSeenWhatsNewId: whatsNewItems[0]?.id,
      }),
    );
  }, [companyId, session, whatsNewItems]);

  const filteredItems = useMemo(() => {
    if (lastSeenWhatsNewId) {
      const positionInArray = whatsNewItems.findIndex(
        i => i.id === lastSeenWhatsNewId,
      );
      if (positionInArray > -1) {
        return whatsNewItems.slice(0, positionInArray);
      }
      return whatsNewItems;
    }

    return whatsNewItems;
  }, [whatsNewItems, lastSeenWhatsNewId]);

  return {
    whatsNewItems,
    filteredItems,
    hideSlideoutMenuOverride,
  };
};
